import React from "react";
import {Autocomplete, Chip, TextField} from "@mui/material";
import {useRegulationsData} from "../contexts/RegulationsProvider";
import {map} from "underscore";

const RegulationTypesInput = () => {
  const {allRegulationTypes, currentFilters, setCurrentFilters} = useRegulationsData();
  const filterType = "regulationTypes";

  const handleChange = (values) =>
    setCurrentFilters((prev) => ({
      ...prev,
      [filterType]: values,
    }));

  return (
    <Autocomplete
      multiple
      id="regulation-types-filter-input"
      options={allRegulationTypes}
      getOptionLabel={(option) => option.displayValue}
      value={currentFilters[filterType]}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      filterSelectedOptions
      onChange={(_, value) => handleChange(value)}
      renderInput={(params) => <TextField {...params} label="Types of Regulations" />}
      renderTags={(value, getTagProps) =>
        map(value, (option, index) => {
          const {key, ...tagProps} = getTagProps({index});
          return <Chip key={key} variant="outlined" label={option.displayValue} {...tagProps} />;
        })}
    />
  );
};

export default RegulationTypesInput;
